<h3 mat-dialog-title>Edit Payment</h3>

<mat-dialog-content>
    <form [formGroup]="formGroup">
        <div class="form-group">
            <label>Payment Date</label>
            <input
                (click)="start.open()"
                [matDatepicker]="start"
                class="form-control date d-inline-block"
                color="accent"
                formControlName="createdAt"
                placeholder="Date..."
            />
            <mat-datepicker #start></mat-datepicker>
        </div>

        <div class="form-group">
            <label>Memo</label>
            <textarea class="form-control" formControlName="memo"></textarea>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <app-button [isDisabled]="isSubmitting"
                mat-dialog-close>{{ 'Cancel' }}
    </app-button>
    <div class="btn-group btn-save-container">
        <app-spinner-button *ngIf="isSubmitting">Saving</app-spinner-button>
        <app-button type="primary"
                    mobileText="{{ 'Update' }}"
                    [buttonClasses]="['mr-0']"
                    [isDisabled]="isSubmitting"
                    (onClick)="submit()">{{ 'Update Payment' }}
        </app-button>
    </div>
</mat-dialog-actions>
